import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const ProcessHeader = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData = labels.menuPages?.sellCar?.processHeader || {};

  return (
    <div className="text-center mb-8 md:mb-12">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4 max-w-2xl mx-auto px-2">
        {headerData.title || "Så Enkelt Säljer Du Din Bil"}
      </h2>
      <p className="text-base md:text-lg text-gray-600 max-w-xl mx-auto px-4">
        {headerData.description ||
          "Vår streamlined process gör bilförsäljning enkel och stressfri."}
      </p>
    </div>
  );
};

export default ProcessHeader;
